import React from 'react';
import "./MessagesToolbar.css";
import TextLabel from "../../../Controls/TextLabel.mjs";
import ImWriteNewIcon from "../../../media/images/ImWriteNewIcon.mjs";
import BackIcon from "../../../media/images/BackIcon.mjs";

const G = window.glob;

const MessagesToolbar = class extends React.Component {
	constructor(props) {
		super(props);
		this.uid = G.generateUid('MessagesToolbar');
	}

	render() {
		return (
			<div className={"AppToolbar MessagesToolbar"} id={this.uid}>
				<div
					className={"ToolbarButton RunningChats"}
					onClick={() => {
						//this.props.openChat();
						this.props.chatList();
					}}
				>
					<BackIcon/>
					<span>
						<TextLabel value={"ImActive"}/>
					</span>
				</div>
				<div className={"ToolbarButtonbar"}>
					<div
						aria-disabled={ this.props.chat === 'new:'}
						className={"ToolbarButton gameRunning ChatArea"}
						onClick={e => {
							e.preventDefault();
							this.props.openChat('new:')
						}}
					>
						<ImWriteNewIcon/>
						<span>
							<TextLabel value={"New chat"}/>
						</span>
					</div>
				</div>
			</div>
		);
	}
}

export default MessagesToolbar;